import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class customerAddressSelectCtrl implements IController {

  customer: any;

  addresses: any;
  selectedId: any;
  isRequired: any;
  onSelect: Function;

  /* @ngInject */
  constructor() {
  }

  onClose(id) {
    const address = _.find(this.addresses, (a) => {
      return a.id === id;
    })
    this.onSelect({address: address, addressId: id});
  }


}

angular
  .module('bringoz.admin.customers')
  .component('customerAddressSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      addresses: '<',
      selectedId: '<',
      isRequired: '@',
      onSelect: '&'
    },
    template: require('./customer-address-select.html').default,
    controller: customerAddressSelectCtrl
  });
